module.exports = __webpack_public_path__ + "img/20.1b0be006.jpg";